import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DropdownOption } from '@maced/angular-components/lib/dropdown/dropdown.model';
import { Subscription } from 'rxjs';

const MOBILE_VIEW_WIDTH: number = 770;

@Component({
  selector: 'app-function-card',
  templateUrl: './function-card.component.html',
  styleUrls: ['./function-card.component.scss']
})
export class FunctionCardComponent {
  showIconClass = true;
  withoutDragActions = false;
  public isMobileView: boolean = false;
  private window: Window;
  badge2 = 100;
  showIcon: boolean = false;
  showDragable: boolean = false;
  preview = `
    <p>Lorem ipsum dolor sit amet consectetuer adipiscing elit</p>
    <p>Aenean commodo ligula eget dolor aenean massa</p>
    <ul>
      <li>Lorem ipsum dolor sit amet consectetuer.</li>
      <li>Aenean commodo ligula eget dolor.</li>
      <li>Aenean massa cum sociis natoque penatibus.</li>
    </ul>
  `;
  title = 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia conseq duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia conseq duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.';
  options: DropdownOption[] = [
    {
      id: 'option41',
      name: 'option41',
      label: 'option 41',
      url: '/function-card'
    },
    {
      id: 'option42',
      name: 'option42',
      label: 'option 42',
      url: '/function-card'
    },
    {
      id: 'option43',
      name: 'option43',
      label: 'option 43',
      url: '/function-card'
    }
  ];
  selectedOptions!: DropdownOption;

  isBrowser = true;
  private queryParamSubscription!: Subscription;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.window = this.document.defaultView!;
  }

  ngOnInit(): void {
    this.queryParamSubscription = this.route.queryParams.subscribe(param => {
      if (param.dropdownId && param.dropdownId === 'dropdownId1') {
        this.options.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions = obj;
          } else {
            obj.active = false;
          }
        });
      }
      if (!this.isBrowser) {
        if (param.showIconClass) {
          this.showIconClass = param.showIconClass === 'on';
        } else {
          this.showIconClass = false;
        }
        if (param.withoutDragActions) {
          this.withoutDragActions = param.withoutDragActions === 'on';
        } else {
          this.withoutDragActions = false;
        }
      }
      if (this.isBrowser) {
        this.getBrowserResolution();
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  getBrowserResolution(): void {
    if (this.window) {
      this.isMobileView = this.window.innerWidth < MOBILE_VIEW_WIDTH;
    }
    this.onChangeIcon();
  }

  onChangeIcon() {
    if (this.isMobileView) {
      this.smallResolution()
    } else {
      this.deskTopResolution();
    }
  }

  smallResolution() {
    if (this.showIconClass && !this.withoutDragActions) {
      this.showIcon = false;
      this.showDragable = false;
    } else if (this.showIconClass && this.withoutDragActions) {
      this.showIcon = true;
      this.showDragable = false;
    } else if (!this.showIconClass && this.withoutDragActions) {
      this.showIcon = false;
      this.showDragable = false;
    }
  }

  deskTopResolution() {
    if (!this.showIconClass && this.withoutDragActions) {
      this.showDragable = true;
      this.showIcon = false;
    } else if (this.showIconClass && this.withoutDragActions) {
      this.showIcon = true;
      this.showDragable = false;
    } else if (!this.showIconClass && !this.withoutDragActions) {
      this.showIcon = false;
      this.showDragable = false;
    }
  }

  ngOnDestroy(): void {
    if (this.queryParamSubscription) {
      this.queryParamSubscription.unsubscribe();
    }
  }
}